import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent {
  constructor(
    public auth: AuthService
  ) {}
}
